import {
    SidebarInset,
} from "@/components/ui/sidebar"
import { AppBar } from "@/layout"
import DashboardCards from "./components/DashboardCards";
import MostSoldProducts from "./components/MostSoldProducts";
import CommissionPartnersLastMonths from "./components/CommissionPartnersLastMonths";
import DriverTasksLastMonths from "./components/DriverTasksLastMonths";
import DriverUnavailabilityAlerts from "./components/DriverUnavailabilityAlerts";
import LargeGroupsAlerts from "./components/LargeGroupsAlerts";
import MostSoldTransfers from "./components/MostSoldTransfers";
import OrdersTimeline from "./components/OrdersTimeline";
import UpcomingOrders from "./components/UpcomingOrders";
import { FormEvent, useState } from "react";
import OrderDetails from "../orders/OrderDetails";
import NewOrders from "./components/NewOrders";
import { Orders } from "@/interface/entityInterface";
import { handleRowClick } from "@/utils/functions";

export const DashboardTravelAgent = () => {
    const [open, setOpen] = useState(false);
    const [order, setOrder] = useState<Orders | null>(null);
    const [manifestLength, setManifestLength] = useState(0)

    return (
        <SidebarInset>
            <AppBar />
            <div className="@container/main flex flex-1 flex-col gap-2 pt-5">
                <DashboardCards />
            </div>
            <div className={`@container/main lg:grid ${manifestLength > 0 ? 'grid-cols-1' : 'grid-cols-6'} place-items-stretch pt-5 px-4 lg:px-6 gap-4`}>
                <div className="w-full h-full mt-5 lg:mt-0 place-self-stretch">
                    <NewOrders setManifestLength={setManifestLength} rowClick={(row: Orders) => handleRowClick(row, setOrder, setOpen)} />
                </div>
                <div className={`w-full h-full mt-5 lg:mt-0 ${manifestLength === 0 && 'col-span-5'}`}>
                    <UpcomingOrders rowClick={(row: Orders) => handleRowClick(row, setOrder, setOpen)} />
                </div>
            </div>
            <div className="@container/main grid sm:grid-cols-2 pt-5 px-4 lg:px-6 gap-4">
                <div className="w-full">
                    <LargeGroupsAlerts />
                    <div className="mt-4" />
                    <DriverUnavailabilityAlerts />
                </div>
                <div className="w-full">
                    <OrdersTimeline orderClick={(row: Orders) => handleRowClick(row, setOrder, setOpen)} />
                </div>
            </div>
            <div className="@container/main flex flex-1 flex-col gap-2">
                <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
                    <div className="*:data-[slot=card]:shadow-xs @xl/main:grid-cols-2 @5xl/main:grid-cols-4 grid grid-cols-1 gap-4 px-4 *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card lg:px-6">
                        <MostSoldProducts />
                        <MostSoldTransfers />
                        <CommissionPartnersLastMonths />
                        <DriverTasksLastMonths />
                    </div>
                </div>
            </div>
            <OrderDetails isSheetOpen={open} setIsSheetOpen={setOpen} selectedOrder={order} />
        </SidebarInset>
    )
}

export default DashboardTravelAgent;